<template>
    <section class="passreports">
        <div class="recentdocdiv">
          <div class="recentdocinnerdiv">
            <div class="rpttitle1">Past Reports & Documents</div>
              <div class="yeardiv">
                <div  v-for="year in pyear" class="yearspan card shadow" @click="$emit('getIdValue', $event.target.value=`${year.yearid}`)"
                 :id="`pitdiv${year.yearid}`"
                >
                  {{ year.yeardesc }}
                </div>
                <div class="tablediv">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th scope="col">Report Description</th>
                        <th scope="col">Download Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="rptyr in getreportbyyears">
                        <td class="tdlinkcss"><a :href="`${myPicUrl}${rptyr.rppdfpath}`" class="tdlinkcss">{{ rptyr.rptitle}}</a></td>
                        <td><a :href="`${myPicUrl}${rptyr.rppdfpath}`" class="tdlinkcss"><i class="fa-solid fa-file-arrow-down downloadlink"></i></a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
        </div>
      </section>
</template>

<script>

export default{
props: ['pyear', 'getreportbyyears', 'myPicUrl'],

methods: {
async getIdValue($event) {
        this.$emit('getIdValue', $event.target.value)
    }
}
}
</script>

<style scoped>


.rpttitle, .rpttitle1 {
    font-size: 30px;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    text-align: center;
    padding: 20px;
    font-weight: bolder;
    color: goldenrod;
  }
  
  
  .rplname {
    padding-top: 40px;
    color:rgb(24, 74, 121);
    font-weight: bold;
  }
  .linkformat {
    text-decoration: none;
    color:rgb(24, 74, 121);
    font-weight: bold;
    font-size: 20px;
  }
  .linkformat1 {
    list-style-type: none;
  }
  
  
  /*Reccent Documents*/

  .recentdocsec {
    padding: 100px;
    background-color: whitesmoke;
  }
  .yearspan {
    float: left; 
    width: 120px; 
    color:rgb(152, 165, 172);
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
    margin-left: 5px;
    margin-top:10px;
  }
  .yeardiv {
    text-align: center; 
  }
  .tablediv {
    padding-top: 200px;
    overflow-x: scroll;
    width: 100%;
  }
  
  .table {
    margin-top: 100px; 
    width: 100%;
  }
  .tdlinkcss {
    text-align: left;
    text-decoration: none;
    padding-left: 40px;
    font-weight: bold;
    font-size: 20px;
    font-family:'Courier New', Courier, monospace;
    color: rgb(96, 112, 153);
  }
  .goalsandperf{
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .goalsperfsec {
    background-color: whitesmoke;
  }
  .goalspeftitle {
    font-size: 30px;
    font-weight: bold;
    color:rgb(152, 165, 172);
    padding-bottom: 50px;
  }
  .activeElement {
    background-color: red;
    font-weight:bold;
  }
  .downloadlink {
    font-size: 30px; 
    float: right; 
    padding-right: 40px; 
    color: orangered;
  }
  
  /*===================MEDIA SCREENS TAMPLATES===============*/
   /* Extra small devices (phones, 600px and down) */
   @media only screen and (max-width: 600px) {
    .reportdiv {
      padding: 20px;
      margin-top: 100px;
      width: 100%;
    }
    .yearspan {
      text-align: center;
    }
    .yeardiv {
      padding-left: 30px;
    }
    .tablediv {
      width: 100%;
      overflow-x: scroll;
  
    }
    .table {
      margin-top: -130px;

    }
    .goalsandperf{
      padding-left: 20px;
      padding-right: 20px;
    }
    .goalspeftitle {
      text-align: center;
    }
    .tdlinkcss {
      padding-left: 10px;
    }
    .downloadlink {
      padding-right: 10px; 

    }
   }
  
   /* Small devices (portrait tablets and large phones, 600px and up) */
   @media only screen and (min-width: 600px) {
  
    .yearspan {
      padding-left: 20px;
      padding-right: 20px;
      text-align: center;
    }
    .tablediv {
      width: 98%;
      overflow-x: scroll;
      padding-left: 10px;
    }
    .table {
      margin-top: -130px;
    }
    .goalsandperf{
      padding-left: 40px;
      padding-right: 40px;
    }
    .goalspeftitle {
      text-align: center;
    }
    .tdlinkcss {
      padding-left: 20px;
    }
    .downloadlink {
      padding-right: 20px; 

    }
   }
   
   /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
  
    .yeardiv {
      padding-left: 20px;
      padding-right: 20px;
      text-align: center;
    }
    .tablediv {
      width: 100%;
      overflow-x: scroll;
      margin-top: -120px;
      padding-left: 10px;
    }
    .goalsandperf{
      padding-left: 60px;
      padding-right: 60px;
    }
    .tdlinkcss {
      padding-left: 20px;
    }
    .downloadlink {
      padding-right: 20px; 

    }
   }
  
   /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .middlecol {
      border-left: thin solid;
      border-right: thin solid;
      height: 370px;
    }
    .yeardiv {
      padding-left: 20px;
      padding-right: 20px;
      text-align: center;
    }
    .tablediv {
      width: 100%;
      overflow-x: scroll;
      margin-top: -120px;
      padding-left: 10px;
    }
    .reportdiv {
      padding: 100px;
      margin-top: 100px;
    }
    .imgwidth {
      width: 100%;
      padding-left: 30px;
      padding-right: 30px; 
    }
   }
  
  
   
   /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  
    .yeardiv {
      padding-left: 200px;
    }
    .tablediv {
      width: 100%;
      overflow-x: scroll;
      margin-top: -120px;
      padding-left: 10px;
    }
    .reportdiv {
      padding: 100px;
      margin-top: 100px;
    }
  
   } 
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
    .txtdata {
      width: 600px;
      text-align: center;
     }
  
    .yeardiv {
      padding-left: 130px;
    }
    .tablediv {
      width: 93%;
      overflow-x: scroll;
  
    }
    .table {
      margin-top: -130px;
    }
    .goalsandperf{
      padding-left: 100px;
      padding-right: 100px;
    }
  
  
  }
  
    
  @media only screen and (min-width: 1600px) {
  
    } 
</style>